import React from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { formatDateTime, fixtureStatusTone } from "../helpers";

function FixtureRow({ fixture, syncing, onSync }) {
  const tone = fixtureStatusTone(fixture.status?.short);
  const home = fixture.homeTeam?.name || "TBD";
  const away = fixture.awayTeam?.name || "TBD";
  const hasScore = fixture.goals?.home != null && fixture.goals?.away != null;
  const statusShort = fixture.status?.short || "—";
  const statusTitle = fixture.status?.long || statusShort;

  return (
    <article className={`alg-fixture-card alg-fixture-card-${tone}${syncing ? " is-syncing" : ""}`}>
      <div className="alg-fixture-card-kickoff">
        <time dateTime={fixture.date || undefined}>{formatDateTime(fixture.date)}</time>
        {fixture.round ? <span className="alg-fixture-round">{fixture.round}</span> : null}
        {fixture.apiId ? (
          <span className="alg-fixture-api-id">API {fixture.apiId}</span>
        ) : null}
      </div>

      <div className="alg-fixture-card-match">
        <div className="alg-fixture-side">
          {fixture.homeTeam?.logo ? (
            <img src={fixture.homeTeam.logo} alt="" className="alg-fixture-crest" />
          ) : (
            <span className="alg-fixture-crest-fallback">{home[0] || "?"}</span>
          )}
          <span className="alg-fixture-side-name">{home}</span>
        </div>

        <div className="alg-fixture-scorebox">
          {hasScore ? (
            <span className="alg-fixture-score-val">
              {fixture.goals.home} – {fixture.goals.away}
            </span>
          ) : null}
          <span
            className={`alg-fixture-pill alg-fixture-pill-${tone}`}
            title={statusTitle}
          >
            {statusShort}
            {fixture.status?.elapsed != null ? ` · ${fixture.status.elapsed}'` : ""}
          </span>
        </div>

        <div className="alg-fixture-side alg-fixture-side-away">
          {fixture.awayTeam?.logo ? (
            <img src={fixture.awayTeam.logo} alt="" className="alg-fixture-crest" />
          ) : (
            <span className="alg-fixture-crest-fallback">{away[0] || "?"}</span>
          )}
          <span className="alg-fixture-side-name">{away}</span>
        </div>
      </div>

      <div className="alg-fixture-card-action">
        <button
          type="button"
          className="alg-fixture-sync-btn"
          onClick={() => onSync(fixture)}
          disabled={syncing}
          title="Pull latest status, score & kickoff from API-Sports"
        >
          {syncing ? (
            <>
              <Loader2 size={13} className="am-spin" aria-hidden />
              <span>Syncing…</span>
            </>
          ) : (
            <>
              <RefreshCw size={13} aria-hidden />
              <span>Sync</span>
            </>
          )}
        </button>
      </div>
    </article>
  );
}

export function FixturesListHeader() {
  return (
    <div className="alg-fixtures-head" aria-hidden>
      <span>Kickoff</span>
      <span>Match</span>
      <span>Action</span>
    </div>
  );
}

export { FixtureRow };
